import { Component } from '@angular/core'
import { Uuid } from '@ftr/contracts/type/shared'
import { CourtSystemParams, routeParam } from '@ftr/routing-paths'

@Component({
  selector: 'ftr-forbidden-page',
  template: '<ftr-forbidden [courtSystemId]="courtSystemId()" />',
  standalone: false,
})
export class ForbiddenPage {
  protected readonly courtSystemId = routeParam<Uuid>(CourtSystemParams.CourtSystemId)
}
